export const stateName = 'directDonation';